import { j as e } from "./atoms-v218.js";
import { useId as a, useFloating as F, useClick as L, useRole as k, useDismiss as M, useInteractions as I, FloatingPortal as P, FloatingFocusManager as A } from "./atoms-v280.js";
import { forwardRef as R, useMemo as l } from "react";
import { useTheme as w } from "styled-components";
import { Gallery as C } from "./atoms-v292.js";
import { Lightbox as D } from "./atoms-v2706.js";
import { Overlay as E } from "./atoms-v2707.js";
import { overlayAnimations as N, standardDialogAnimations as O } from "./atoms-v2708.js";
import { motion as m } from "./atoms-v2709.js";
import { AnimatePresence as T } from "./atoms-v2710.js";
const G = R(
  ({ defaultSelectedSlide: c, id: t, isOpen: i, root: r, setIsOpen: d, slides: s = [] }, g) => {
    const n = w(), h = a(), f = a(), x = l(() => m(E), []), p = l(() => m(D), []), { context: o, refs: u } = F({
      onOpenChange: d,
      open: i
    }), b = L(o, {
      enabled: !0,
      event: "click",
      ignoreMouse: !1,
      keyboardHandlers: !1,
      toggle: !1
    }), v = k(o, { role: "dialog" }), y = M(o, { outsidePressEvent: "mousedown" }), { getFloatingProps: j } = I([b, y, v]);
    return /* @__PURE__ */ e.jsx(P, { ...r ? { root: r } : {}, children: /* @__PURE__ */ e.jsx(T, { children: i && s.length > 0 && /* @__PURE__ */ e.jsx(
      x,
      {
        lockScroll: !0,
        animate: "visible",
        className: "modal-overlay",
        exit: "hidden",
        id: t,
        initial: "hidden",
        ref: g,
        variants: N(n),
        children: /* @__PURE__ */ e.jsx(A, { context: o, children: /* @__PURE__ */ e.jsx(
          p,
          {
            "aria-describedby": f,
            "aria-labelledby": h,
            ref: u.setFloating,
            variants: O(n),
            ...j(),
            children: /* @__PURE__ */ e.jsx(
              C,
              {
                defaultSelectedSlide: c,
                id: "gallery",
                slides: s,
                title: "Test Lightbox",
                variant: "v3"
              }
            )
          }
        ) })
      },
      t
    ) }) });
  }
);
G.displayName = "Lightbox";
export {
  G as Lightbox
};
